import React from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormTextarea,
  CRow,
} from '@coreui/react-pro'
import { setWithdrawalGroup, submitCreateWithdrawalGroup } from './model'
import { useCreateWithdrawalGroup } from './hooks'
export const CreateWithdrawalGroup = () => {
  const { withdrawalGroup, loading } = useCreateWithdrawalGroup()
  const handleChange = (event: {
    currentTarget: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.currentTarget.type === 'checkbox'
        ? event.currentTarget.checked
        : event.currentTarget.value

    setWithdrawalGroup({
      ...withdrawalGroup,
      [event.currentTarget.name]: value,
    })
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Create payment group</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={withdrawalGroup.name}
                  onChange={handleChange}
                  label="Name"
                />
              </CCol>
            </CRow>
            <CButton
              className="mb-3"
              disabled={loading}
              onClick={() => submitCreateWithdrawalGroup(withdrawalGroup)}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  )
}
